import React from 'react';
import {
  Button, Modal,
} from 'rsuite';
import Remind from '@rsuite/icons/legacy/Remind';
import { TransformationResponseDto } from '../services/ApiType';
import { showSuccessMessage } from './Toaster';
import { deleteTransformation } from '../services/TransformationsService';

interface Props {
  open: boolean;
  transformation: TransformationResponseDto;
  onClose: () => void;
  onSuccess?: () => void;
}

function DeleteTransformationAlert({
  open, transformation, onClose, onSuccess,
}: Props) {
  const onCancel = () => {
    onClose();
  };

  const onDelete = () => {
    deleteTransformation(transformation.id)
      .then(() => {
        showSuccessMessage('Item was successfully deleted.');
        onSuccess?.();
      })
      .finally(() => onClose());
  };

  return (
    <Modal open={open} onClose={onClose} role="alertdialog" size="xs">
      <Modal.Header>
        <Remind style={{ color: '#ffb300', fontSize: 16 }} title="text" />
        <b style={{ padding: 10 }}>Deletion</b>
      </Modal.Header>
      <Modal.Body>
        Do you really want delete item with id:
        {' '}
        {transformation.id}
        {' '}
        ?
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onDelete} color="red" appearance="primary">
          Delete
        </Button>
        <Button onClick={onCancel} appearance="subtle">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

DeleteTransformationAlert.defaultProps = {
  onSuccess: undefined,
};

export default DeleteTransformationAlert;
